import React from "react";
import * as FontAwesome from "react-icons/fa";
import "./IconPicker.scss";

interface IconListProps {
  icons: string[];
  setChosenIcon: (icon: string) => void;
  setIsPickerVisible: (visible: boolean) => void;
}

function IconList({ icons, setChosenIcon, setIsPickerVisible }: IconListProps) {
  return icons.map(icon => {
    const MyIcon = (FontAwesome as Record<string, React.ComponentType<{ className?: string }>>)[icon];
    // Some Font Awesome icons were dropped in react-icons v5; a layout saved
    // before the upgrade can still reference one.
    if (!MyIcon) {
      return null;
    }
    return (
      <div
        key={icon}
        className="icon-container"
        onClick={() => {
          setChosenIcon(icon);
          setIsPickerVisible(false);
        }}
        aria-label={`${icon} Icon`}
      >
        <MyIcon className="icon" />
      </div>
    );
  });
}

export default React.memo(IconList);
